import { ThresholdPill } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

const Content = styled.div`
	width: 100%;
`;
export const LeftContent = styled.div`
	display: inline-block;
`;
LeftContent.displayName = 'LeftContent';

const RightContent = styled.div<{ verticalAlign?: string }>`
	display: inline-block;
	text-align: right;
	${(props) => (props.verticalAlign ? 'vertical-align: ' + props.verticalAlign : null)}
`;
RightContent.displayName = 'RightContent';

export const AddMargin = styled.div`
	margin-right: 22px;
`;

export interface ISectionHeaderContentWithCount {
	text: string;
	count: number;
	threshold?: number;
}

export class SectionHeaderContentWithCount extends React.Component<ISectionHeaderContentWithCount> {
	public render() {
		const { text, count, threshold } = this.props;

		return (
			<Content>
				<LeftContent className='col-lg-10 col-sm-12'>{text}</LeftContent>
				<RightContent className='col-lg-2 col-sm-12'>
					<AddMargin>
						<ThresholdPill count={count} threshold={threshold} />
					</AddMargin>
				</RightContent>
			</Content>
		);
	}
}
